import { ballArr, count, singleDouble, smallBig, dragonTiger } from '../resPatterns.js';

const ssc = {};

const pk10 = {};

const getscc = (list, num) => {
  let res = Object.assign({}, ssc);
  if (list.length == 0) {
    return res;
  }
  return list.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    let rescount = count(arr);

    if (!a['count']) {
      a['count'] = {
        single: 0,
        double: 0,
        big: 0,
        small: 0
      };
    }
    singleDouble(rescount) == 0 ? a['count'].single++ : a['count'].double++;
    if (list[0].parentType == 2) {
      smallBig(rescount, 60) == 0 ? a['count'].small++ : smallBig(rescount, 60) == 1 ? a['count'].big++ : '';
    } else {
      smallBig(rescount, 45) == 0 ? a['count'].small++ : a['count'].big++;
    }

    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = {
          single: 0,
          double: 0,
          big: 0,
          small: 0
        };
      }
      if (arr[i] != 11) {
        singleDouble(arr[i]) == 0 ? a[i].single++ : a[i].double++;
        smallBig(arr[i], num) == 0 ? a[i].small++ : a[i].big++;
      }
    });
    // console.log(a);
    return a;
  }, res);
};
const getpk10 = list => {
  let respk10 = Object.assign({}, pk10);
  if (list.length == 0) {
    return respk10;
  }
  return list.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    let rescount = arr[0] + arr[1];
    if (!a['gyh']) {
      a['gyh'] = {
        single: 0,
        double: 0,
        big: 0,
        small: 0
      };
    }
    singleDouble(rescount) == 0 ? a['gyh'].single++ : a['gyh'].double++;
    smallBig(rescount, 20) == 0 ? a['gyh'].small++ : a['gyh'].big++;

    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = {
          single: 0,
          double: 0,
          big: 0,
          small: 0,
          dragon: 0,
          tiger: 0
        };
      }
      singleDouble(arr[i]) == 0 ? a[i].single++ : a[i].double++;
      smallBig(arr[i], 10) == 0 ? a[i].small++ : a[i].big++;
      if (i < 5) {
        dragonTiger(arr[i], arr[9 - i]) == 0 ? a[i].dragon++ : a[i].tiger++;
      }
    });
    return a;
  }, respk10);
};
const gethpten = list => {
  let res = {};
  if (list.length == 0) {
    return res;
  }

  const result = list.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    let rescount = count(arr);

    if (!a['count']) {
      a['count'] = {
        single: 0,
        double: 0,
        big: 0,
        small: 0
      };
    }

    singleDouble(rescount) == 0 ? a['count'].single++ : a['count'].double++;
    //总和小于84 即为小。
    rescount < 84 ? a['count'].small++ : a['count'].big++;

    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = {
          dragon: 0,
          tiger: 0
        };
      }

      if (i < 4) {
        //每次开奖结果头尾两数比较，大的为龙++1；否则虎++1
        arr[i] > arr[arr.length - i - 1] ? a[i].dragon++ : a[i].tiger++;
      }
    });

    return a;
  }, res);
  // console.log('cccccc', result)
  return result;
};
const getNumPattern = (type, list) => {
  switch (type) {
    case 'ssc':
      break;
    case 'PK10':
      break;

    default:
      return {};
      break;
  }
};

export default (type, list) => {
  if (type == 'ssc') {
    return getscc(list, 9);
  }
  if (type == 'PK10' || type == 'nn') {
    return getpk10(list);
  }
  if (type == 'choose5') {
    return getscc(list, 11);
  }
  if (type == 'hpten') {
    return gethpten(list);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/getNumPattern.js